import { TrackingEventConstants } from '../constants/tracking'
import { TAB_NAMES } from '../mappings/navigation'

export type TabNames = keyof typeof TAB_NAMES

export interface Navigation {
  activeTab: TabNames[number]
}

export enum HomeownerNavigationComponents {
  ADD_A_HOME = 'add_a_home',
}

export enum BuyerNavigationComponents {
  BUYING_REPORT = 'buying_report',
  DIVIDER = 'explore_markets',
  EXPLORE_MARKETS = 'divider',
  FAVORITE_LISTINGS = 'favorite_listings',
  SAVED_SEARCHES = 'saved_searches',
  SEARCH_HOMES = 'search_homes',
  LISTING = 'listing',
}

export type BuyerNavigationLinksMappedToAmplitude = {
  [BuyerNavigationComponents.BUYING_REPORT]: typeof TrackingEventConstants.BUYING_REPORT
  [BuyerNavigationComponents.EXPLORE_MARKETS]: typeof TrackingEventConstants.EXPLORE_MARKETS
  [BuyerNavigationComponents.FAVORITE_LISTINGS]: typeof TrackingEventConstants.FAVORITE_LISTINGS
  [BuyerNavigationComponents.SAVED_SEARCHES]: typeof TrackingEventConstants.SAVED_SEARCHES
  [BuyerNavigationComponents.SEARCH_HOMES]: typeof TrackingEventConstants.SEARCH_HOMES
}
